import { render, staticRenderFns } from "./tabsComp.vue?vue&type=template&id=0a338b88&"
import script from "./tabsComp.vue?vue&type=script&lang=js&"
export * from "./tabsComp.vue?vue&type=script&lang=js&"
import style0 from "./tabsComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports